import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter'
})
export class FilterPipe implements PipeTransform {
    transform(items: any[], searchText: string): any {
        if (!items) return [];
        if (!searchText) return items;
        searchText = searchText.toLowerCase();
        return items.filter(it => {
            if(it.data){
                if(it.data.last_name){
                    return it.data.last_name.toLowerCase().includes(searchText);
                } else if(it.data.name){
                    return it.data.name.toLowerCase().includes(searchText);
                }
            }else{
                if (it.last_name) {
                    return it.last_name.toLowerCase().includes(searchText);
                } else if (it.name) {
                    return it.name.toLowerCase().includes(searchText);
                }
            }
            return;
        });
    }
    /*transform(items: any[], term: string): any {
        // I am unsure what id is here. did you mean title?
        return items.filter(item => item.id.indexOf(term) !== -1);
    }*/
}

@Pipe({
    name: 'keys'
})
export class KeysPipe implements PipeTransform {
    transform(items: any[], searchText: string): any {
        let arr = [];
        for(let i in items)
            arr.push(items[i]);
        return arr;    
    }
}


// WEBPACK FOOTER //
// ./src/app/filter.pipe.ts